import { render, staticRenderFns } from "./EDrawerMotivoAula.vue?vue&type=template&id=97d2f4b8&scoped=true&"
import script from "./EDrawerMotivoAula.vue?vue&type=script&lang=js&"
export * from "./EDrawerMotivoAula.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d2f4b8",
  null
  
)

export default component.exports